import api from 'api';
import axios from 'axios';
import { FC, useContext, useEffect, useState } from 'react';

import { debug } from 'utils/helpers';

import { StickyContext } from 'state/contexts/sticky';

import { Sticky } from 'components/elements';
import { PatientContext } from 'state/contexts/patient';
import { ActionTypes } from 'state/reducers/sticky';

type StickyNote = {
  id: number;
  description: string;
};

const StickyNotes: FC = () => {
  const { stickyState, stickyDispatch } = useContext(StickyContext);
  const { patientState } = useContext(PatientContext);
  const patientId = patientState.current!.id;

  const [notes, setNotes] = useState<StickyNote[]>([]);

  const source = axios.CancelToken.source();

  const handleClose = async (id: number) => {
    try {
      stickyDispatch({
        type: ActionTypes.Delete,
        payload: {
          patientId,
          id,
        },
      });

      await api().put(`sticks/${id}?auth_token=AUTH_TOKEN`);
    } catch (err) {
      debug(`Error: ${err}`);
    }
  };

  const getStickyNotes = async () => {
    try {
      const {
        data: { data },
      } = await api().get(`sticks/${patientId}/AUTH_TOKEN`, {
        cancelToken: source.token,
      });

      stickyDispatch({
        type: ActionTypes.Set,
        payload: {
          patientId,
          data,
        },
      });
    } catch (err) {
      if (!axios.isCancel(err)) {
        debug(`Error: ${err}`);
      }
    }
  };

  useEffect(() => {
    setNotes(stickyState.data[patientId] || []);
  }, [stickyState.data, patientId]);

  useEffect(() => {
    if (stickyState.reload !== 0) {
      setTimeout(() => {
        getStickyNotes();
      }, 1000);
    }
  }, [stickyState.reload]);

  useEffect(() => {
    setNotes([]);
    getStickyNotes();

    return () => {
      source.cancel();
    };
  }, [patientId]);

  return (
    <>
      {notes.map((sticky) => (
        <Sticky
          key={`sticky-${sticky.id}`}
          backgroundColor='turquoise'
          color='teal'
          onClose={() => handleClose(sticky.id)}>
          Sticky Note: {sticky.description}
        </Sticky>
      ))}
    </>
  );
};

export default StickyNotes;
